export const data = [
  {
    id: 1,
    name: "Volkan Demirel",
    img: "https://encrypted-tbn1.gstatic.com/licensed-image?q=tbn:ANd9GcTqFQ63Qd16jBOpRYvez50IjJXqSass7ESuCdp19s22mWN_DOEysur4bInincZB8Pmmz8l_BuWR2Kb61tw",
    statistics: [
      "🏟️  Game: 525",
      "⚽ Score: 0",
      "🎯  Assists: 2",
      "🏆 Trophy: 10",
    ],
  },
  {
    id: 2,
    name: "Aykut Kocaman",
    img: "https://i.pinimg.com/564x/f6/dd/4d/f6dd4d49e6cea88b8de5abf408a9cf71.jpg",
    statistics: [
      "🏟️ Game: 258",
      "⚽️ Score: 160",
      "🎯 Assists: 58",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 3,
    name: "Lefter Küçükandonyadis",
    img: "https://cdn.ntvspor.net/dbb4275c659c4bbf82b3cb0fcf2f4039.jpg?mode=crop&w=940&h=626",
    statistics: [
      "🏟️ Game: 78",
      "⚽️ Score: 33",
      "🎯 Assists: 31",
      "🏆 Trophy: 3",
    ],
  },

  {
    id: 4,
    name: "Alex de Souza",
    img: "https://upload.wikimedia.org/wikipedia/commons/4/40/Alexsandro_de_Souza.jpg",
    statistics: [
      "🏟️ Game: 344",
      "⚽️ Score: 171",
      "🎯 Assists: 146",
      "🏆 Trophy: 6",
    ],
  },
  {
    id: 5,
    name: "Oguz Cetin",
    img: "https://s1.dmcdn.net/v/SEYPY1VYJxsphNVKn/x1080",
    statistics: [
      "🏟️ Game: 286",
      "⚽️ Score: 57",
      "🎯 Assists: 89",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 6,
    name: "Semih Şentürk",
    img: "https://image.hurimg.com/i/hurriyet/75/750x422/5b954fd118c773043c6a3814.jpg",
    statistics: [
      "🏟️ Game: 281",
      "⚽️ Score: 87",
      "🎯 Assists: 52",
      "🏆 Trophy: 9",
    ],
  },
  {
    id: 7,
    name: "Mehmet Aurélio",
    img: "https://tmssl.akamaized.net//images/foto/galerie/mehmet-aurelio-fenerbahce-1590407019-39481.jpg",
    statistics: [
      "🏟️ Game: 222",
      "⚽️ Score: 20",
      "🎯 Assists: 34",
      "🏆 Trophy: 4",
    ],
  },
  {
    id: 8,
    name: "Gökhan Gönül",
    img: "https://www.cumhuriyet.com.tr/Archive/2021/7/2/1849091/kapak_072926.jpg",
    statistics: [
      "🏟️ Game: 361",
      "⚽️ Score: 14",
      "🎯 Assists: 54",
      "🏆 Trophy: 7",
    ],
  },

  {
    id: 9,
    name: "İlker Yağcıoğlu",
    img: "https://pbs.twimg.com/media/FCOsYXEVgAQaGWv.jpg:large",
    statistics: [
      "🏟️ Game: 212",
      "⚽️ Score: 5",
      "🎯 Assists: 36",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 10,
    name: "Tuncay Şanlı",
    img: "https://www.cumhuriyet.com.tr/Archive/2023/5/13/2080995/kapak_165540.jpg",
    statistics: [
      "🏟️ Game: 207",
      "⚽️ Score: 77",
      "🎯 Assists: 33",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 11,
    name: "İsmail Kartal",
    img: "https://s2.dmcdn.net/v/V30P71ad8colHVyAg/x1080",
    statistics: [
      "🏟️ Game: 203",
      "⚽️ Score: 14",
      "🎯 Assists: 14",
      "🏆 Trophy: 5",
    ],
  },
  {
    id: 12,
    name: "Cristian Baroni",
    img: "https://media05.ligtv.com.tr/img/news/2012/10/14/cristian-baroni.jpg",
    statistics: [
      "🏟️ Game: 200",
      "⚽️ Score: 29",
      "🎯 Assists: 23",
      "🏆 Trophy: 6",
    ],
  },
  {
    id: 13,
    name: "Ferdi Kadıoğlu",
    img: "https://img.piri.net/mnresize/712/-/piri/upload/3/2024/3/5/b93a218e-3ejmtxzb26va0ayngy0gc.png",
    statistics: [
      "🏟️ Game: 199",
      "⚽️ Score: 17",
      "🎯 Assists: 22",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 14,
    name: "Diego Lugano",
    img: "https://i.redd.it/x6p25l6esg2c1.jpg",
    statistics: [
      "🏟️ Game: 188",
      "⚽️ Score: 27",
      "🎯 Assists: 5",
      "🏆 Trophy: 4",
    ],
  },
  {
    id: 15,
    name: "Moussa Sow",
    img: "https://i.haberglobal.com.tr/storage/haber/2020/04/18/moussa-sow-fenerbahce-tercihimden-dolayi-gercekten-cok-mutluyum_1587200377.jpg",
    statistics: [
      "🏟️ Game: 185",
      "⚽️ Score: 75",
      "🎯 Assists: 32",
      "🏆 Trophy: 4",
    ],
  },
  {
    id: 16,
    name: "Elvir Bolic",
    img: "https://i.pinimg.com/564x/4a/02/aa/4a02aa35af579b38c303230de864ad17.jpg",
    statistics: [
      "🏟️ Game: 173",
      "⚽️ Score: 76",
      "🎯 Assists: 33",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 17,
    name: "Deivid de Souza",
    img: "https://yasamoykusu.com/_docs/story/Deivid_de_Souza0_yasamoykusu.jpg",
    statistics: [
      "🏟️ Game: 150",
      "⚽️ Score: 40",
      "🎯 Assists: 24",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 18,
    name: "Bright Osayi-Samuel",
    img: "https://tmssl.akamaized.net/images/foto/galerie/bright-osayi-samuel-fenerbahce-2023-2024-1703080514-124594.jpg?lm=1703080535",
    statistics: [
      "🏟️ Game: 139",
      "⚽️ Score: 7",
      "🎯 Assists: 13",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 19,
    name: "Ümit Özat",
    img: "https://i.pinimg.com/736x/02/a9/e8/02a9e8227a8db86bcebe74b2670aa26b.jpg",
    statistics: [
      "🏟️ Game: 240",
      "⚽️ Score: 12",
      "🎯 Assists: 36",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 20,
    name: "Bülent Uygun",
    img: "https://volkanbk3.wordpress.com/wp-content/uploads/2008/09/liveimages5cyenifotoanaliz5ctesadfcfen20futbolcu20oldu5c07.jpg?w=584",
    statistics: [
      "🏟️ Game: 134",
      "⚽️ Score: 48",
      "🎯 Assists: 22",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 21,
    name: "Dirk Kuyt",
    img: "https://media.fenerbahce.org/FB/media/FB/pic_lib/2013-04-04_kuyt538.jpg",
    statistics: [
      "🏟️ Game: 130",
      "⚽️ Score: 37",
      "🎯 Assists: 28",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 22,
    name: "İrfan Can Kahveci",
    img: "https://ia.tmgrup.com.tr/14da24/1160/650/0/0/2048/1147?u=https://i.tmgrup.com.tr/rt/2024/03/05/irfan-can-kahveciden-mujdeli-haber-1709624130484.jpg",
    statistics: [
      "🏟️ Game: 129",
      "⚽️ Score: 29",
      "🎯 Assists: 27",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 23,
    name: "Rıdvan Dilmen",
    img: "https://i.pinimg.com/originals/c4/90/b3/c490b37a3f226ae3b12dd5788605ddb9.jpg",
    statistics: [
      "🏟️ Game: 127",
      "⚽️ Score: 36",
      "🎯 Assists: 54",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 24,
    name: "Miroslav Stoch",
    img: "https://trthaberstatic.cdn.wp.trt.com.tr/resimler/88000/89974.jpg",
    statistics: [
      "🏟️ Game: 122",
      "⚽️ Score: 20",
      "🎯 Assists: 16",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 25,
    name: "Martin Skrtel",
    img: "https://tmssl.akamaized.net/images/foto/big/martin-skrtel-von-fenerbahce-istanbul-1549958201-20450.jpg?lm=1549958210",
    statistics: [
      "🏟️ Game: 119",
      "⚽️ Score: 7",
      "🎯 Assists: 3",
      "🏆 Trophy: 0",
    ],
  },
  {
    id: 26,
    name: "Fabio Luciano",
    img: "https://media06.ligtv.com.tr/img/gallery/2019326_lucianonun_unutamadg_fenerbahce_11i/luciano.jpg",
    statistics: [
      "🏟️ Game: 119",
      "⚽️ Score: 17",
      "🎯 Assists: 5",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 27,
    name: "Bruno Alves",
    img: "https://media.fenerbahce.org/FB/media/FB/pic_lib/balves538_36536_3594263.jpg",
    statistics: [
      "🏟️ Game: 101",
      "⚽️ Score: 4",
      "🎯 Assists: 3",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 28,
    name: "Andre Santos",
    img: "https://iaaspr.tmgrup.com.tr/b72ab5/613/641/0/0/0/0?u=http://i.aspor.com.tr/galeri/fenerbahce/andre-santos-fenerbahceye-geri-mi-donuyor/1_v2_lb.jpg",
    statistics: [
      "🏟️ Game: 78",
      "⚽️ Score: 17",
      "🎯 Assists: 4",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 29,
    name: "Toni Schumacher",
    img: "https://i.pinimg.com/564x/e1/c0/77/e1c077dac61ba6921762f4a1dc2ec767.jpg",
    statistics: [
      "🏟️ Game: 105",
      "⚽️ Score: 0",
      "🎯 Assists: 0",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 30,
    name: "Raúl Meireles",
    img: "https://image.hurimg.com/i/hurriyet/75/750x422/55ea6323f018fbb8f87ca2ca.jpg",
    statistics: [
      "🏟️ Game: 105",
      "⚽️ Score: 8",
      "🎯 Assists: 12",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 31,
    name: "Roberto Carlos",
    img: "https://iaftm.tmgrup.com.tr/c980fc/1200/627/0/19/1200/647?u=https://iftm.tmgrup.com.tr/2022/02/01/roberto-carlos-sahalara-geri-donuyor-yeni-takimi-1643701366917.jpeg",
    statistics: [
      "🏟️ Game: 104",
      "⚽️ Score: 10",
      "🎯 Assists: 10",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 32,
    name: "Pierre Webó",
    img: "https://image.milimaj.com/i/milliyet/75/869x477/5c8e21a945d2a09e00a316f1.jpg",
    statistics: [
      "🏟️ Game: 89",
      "⚽️ Score: 33",
      "🎯 Assists: 11",
      "🏆 Trophy: 3",
    ],
  },
  {
    id: 33,
    name: "Robin van Persie",
    img: "https://i.pinimg.com/736x/ad/61/6f/ad616ff979f67eea60495e73293f9876.jpg",
    statistics: [
      "🏟️ Game: 87",
      "⚽️ Score: 36",
      "🎯 Assists: 7",
      "🏆 Trophy: 0",
    ],
  },

  {
    id: 34,
    name: "Pierre van Hooijdonk",
    img: "https://pbs.twimg.com/media/FP_bE3FWUAYU6_k.jpg:large",
    statistics: [
      "🏟️ Game: 63",
      "⚽️ Score: 35",
      "🎯 Assists: 12",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 35,
    name: "Mateja Kežman",
    img: "https://image.cnnturk.com/i/cnnturk/75/740x416/527e3038992df107301d4cb6.jpg",
    statistics: [
      "🏟️ Game: 69",
      "⚽️ Score: 30",
      "🎯 Assists: 11",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 36,
    name: "Edin Dzeko",
    img: "https://cdn.ntvspor.net/ebfa28f15fe34dd5bf684146966b1eba.jpg?mode=crop&w=940&h=626",
    statistics: [
      "🏟️ Game: 46",
      "⚽️ Score: 25",
      "🎯 Assists: 10",
      "🏆 Trophy: 0",
    ],
  },
  {
    id: 37,
    name: "Can Bartu",
    img: "https://www.gazetekadikoy.com.tr/Uploads/gazetekadikoy.com.tr/haberler/200495576260797-img.jpg",
    statistics: [
      "🏟️ Game: 62",
      "⚽️ Score: 26",
      "🎯 Assists: 11",
      "🏆 Trophy: 5",
    ],
  },
  {
    id: 38,
    name: "Stephen Appiah",
    img: "https://pbs.twimg.com/media/EVGVMQXUUAAMjga?format=jpg&name=4096x4096",
    statistics: [
      "🏟️ Game: 90",
      "⚽️ Score: 17",
      "🎯 Assists: 11",
      "🏆 Trophy: 2",
    ],
  },
  {
    id: 39,
    name: "Nicolas Anelka",
    img: "https://cdn1.ntv.com.tr/gorsel/sMtybA5AgUO1hYgEhweYGg.jpg?width=1000&mode=crop&scale=both",
    statistics: [
      "🏟️ Game: 57",
      "⚽️ Score: 16",
      "🎯 Assists: 15",
      "🏆 Trophy: 1",
    ],
  },
  {
    id: 40,
    name: "Dusan Tadic",
    img: "https://tmssl.akamaized.net/images/foto/galerie/dusan-tadic-fenernahce-2023-24-1689579033-111706.jpg?lm=1689579051",
    statistics: [
      "🏟️ Game: 56",
      "⚽️ Score: 16",
      "🎯 Assists: 16",
      "🏆 Trophy: 0",
    ],
  },
];
